"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EGradientType = exports.contrastToFore = exports.EGraphicContrast = void 0;
const VibescoutFrontendStyleConfig_1 = require("../config/VibescoutFrontendStyleConfig");
var EGraphicContrast;
(function (EGraphicContrast) {
    EGraphicContrast["HIGH"] = "HIGH";
    EGraphicContrast["MID"] = "MID";
    EGraphicContrast["LOW"] = "LOW";
})(EGraphicContrast || (exports.EGraphicContrast = EGraphicContrast = {}));
exports.contrastToFore = {
    [EGraphicContrast.HIGH]: VibescoutFrontendStyleConfig_1.EForeContrast.strong,
    [EGraphicContrast.MID]: VibescoutFrontendStyleConfig_1.EForeContrast.regular,
    [EGraphicContrast.LOW]: VibescoutFrontendStyleConfig_1.EForeContrast.subtle,
    [VibescoutFrontendStyleConfig_1.EForeContrast.strong]: VibescoutFrontendStyleConfig_1.EForeContrast.strong,
    [VibescoutFrontendStyleConfig_1.EForeContrast.regular]: VibescoutFrontendStyleConfig_1.EForeContrast.regular,
    [VibescoutFrontendStyleConfig_1.EForeContrast.subtle]: VibescoutFrontendStyleConfig_1.EForeContrast.subtle,
    [VibescoutFrontendStyleConfig_1.EForeContrast.extra]: VibescoutFrontendStyleConfig_1.EForeContrast.extra,
};
var EGradientType;
(function (EGradientType) {
    EGradientType["none"] = "none";
    EGradientType["flat"] = "flat";
    EGradientType["radial"] = "radial";
    EGradientType["linear"] = "linear";
    EGradientType["repeatingRadial"] = "repeating-radial";
    EGradientType["repeatingLinear"] = "repeating-linear";
})(EGradientType || (exports.EGradientType = EGradientType = {}));
